export default __webpack_public_path__ + "static/media/Website.e0bc5976.png";